<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
        <!------------------------search---------------------->
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        	<el-form-item ref="query" :model="query">
	            <el-select v-model="query.level" placeholder="请选择版本号" style="width:130px">
		            <el-option v-for="(item,index) in levels" :key="index" :label="item.name" :value="item.id"></el-option>
		        </el-select> 
	        </el-form-item>
	        <el-form-item ref="query" :model="query">
	        	<el-select v-model="query.validtime" placeholder="请选择到期时间" style="width:150px">
		            <el-option v-for="(item,index) in validtime" :key="index" :label="item.name" :value="item.id"></el-option>
		        </el-select>
	        </el-form-item>
	        <el-form-item ref="query" :model="query">
	            <el-input placeholder="店铺名称 / 地址 / 电话" v-model="query.key" ></el-input>
	        </el-form-item>
	        <el-form-item>
	            <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
	        </el-form-item>
        </el-form>
        <!------------------------search end---------------------->
    	
    	<!--------------------------- 店铺信息列表 -------------------------->
    	<div class="backborder2" style="margin-top:10px">
		    <el-table :data="lists" v-loading="listLoading">
		        <el-table-column prop="id" label="编号" width="100"></el-table-column>
		        <el-table-column prop="version" label="店铺版本" width="100"></el-table-column>
		        <el-table-column prop="shopname" label="店铺名称" width="150"></el-table-column>
		        <el-table-column prop="address" label="地址"></el-table-column>
		        <el-table-column prop="validitytime" label="到期时间" width="150" align="center"></el-table-column>
		        <el-table-column prop="endtime" label="距离到期剩余时间" width="150" align="center"></el-table-column>
		        <el-table-column prop="phone" label="联系电话" width="150" align="center"></el-table-column>
		        <el-table-column label="操作" width="150" align="center">
			        <template slot-scope="scope">
			            <el-button type="primary" size="mini" icon="el-icon-tickets" @click="getShopinfo(scope.row)" v-if="actionauth.get_shop_info=='true'">查看</el-button>
			            <!--
			            <el-button type="danger" size="mini" icon="el-icon-tickets"></el-button>
			            -->
			        </template>
		        </el-table-column>
		    </el-table>
		    <div class="block">
		        <!--分页begin-->
		        <el-pagination
		          @size-change="pageSizeChange"
		          @current-change="pageCurrentChange"
		          :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="total_rows">
		        </el-pagination>
		        <!--分页end-->
		    </div>
	    </div>
	    
	    <!------------------------  指定店铺信息库存记录列表  --------------------------->
	    <el-dialog :title="shopname" :visible.sync="shopsinfosDialog" width="80%" top="5vh">
		    <el-menu :default-active="shopindex" class="el-menu-demo" mode="horizontal">
			  <el-menu-item index="1" @click="getshopinventorylists" v-if="actionauth.inventory_log=='true'">库存记录</el-menu-item>
			  <el-menu-item index="2" @click="saleslog" v-if="actionauth.sell_log=='true'">销售记录</el-menu-item>
			  <el-menu-item index="3" @click="salestatlog">产品统计</el-menu-item>
			  <el-menu-item index="4" @click="getsalesall">营业走势</el-menu-item>
			  <el-menu-item index="5" @click="getcatesall">分类统计</el-menu-item>
			</el-menu>
			
			<!------------------------------------  店铺销售记录  -------------------------------------------->
			<div>
				<el-form :inline="true" class="demo-form-inline"  style="margin-top:15px" v-if="menunumber==1">
		            <el-form-item style="width:15%">
			            <el-select v-model="shopInventoryquery.brandid" filterable placeholder="按品牌" @change="inventoryselect=true">
			              	<el-option label="不分品牌" value="0" ></el-option>
			                <el-option v-for="(item,index) in brandlists" :label="item.companyname" :value="item.id" :key="index"></el-option>
			            </el-select>
		            </el-form-item>
		            <el-form-item style="width:15%">
			            <el-cascader :options="catlists" v-model="shopInventoryquery.catid" placeholder="请选择分类" @change="inventoryselect=true"></el-cascader>
		            </el-form-item>
		            <el-form-item>
		            	<el-input placeholder="商品名称" size="25" v-model="shopInventoryquery.key" @change="inventoryselect=true"></el-input>
		            </el-form-item>
		            <el-form-item>
		            	<el-button type="primary" icon="el-icon-search" @click="getshopinventory()">查询</el-button>
		            </el-form-item>
	        	</el-form>
	        	
	        	<el-table :data="shopinventorydata" v-loading="inventoryLoading" tooltip-effect="dark" v-if="menunumber==1">
				    <el-table-column prop="brandname" label="品牌" width="120"></el-table-column>
				    <el-table-column prop="name" label="名称"></el-table-column>
				    <el-table-column prop="spec" label="规格"></el-table-column>
				    <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
				    <el-table-column prop="inventory" label="库存" width="120" align="center"></el-table-column>
			    </el-table>
			    <div class="block" v-if="menunumber==1">
			        <el-pagination
			            @size-change="productinventoryPageSizeChange"
			            @current-change="productinventoryPageCurrentChange"
			            :current-page="shopInventoryquery.p"
			            :page-sizes="[10, 20, 50]"
			            :page-size="shopInventoryquery.rollpage"
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="shopinventoryrow">
			        </el-pagination>
			    </div>
			</div>
  			<!------------------------------------  店铺销售记录  -------------------------------------------->
			
		  			
  			<!------------------------------------  店铺销售记录 -------------------------------------------->
  			<div>
	  			<el-form :inline="true" class="demo-form-inline"  style="margin-top:15px" v-if="menunumber==2">
		            <el-form-item style="width:25%">
			            <el-date-picker v-model="salequery.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
		            </el-form-item>
		            <el-form-item>
		            	<el-button type="primary" icon="el-icon-search" @click="getsalesdata()">查询</el-button>
		            </el-form-item>
	        	</el-form>
	
			    <el-table :data="salelists" v-loading="saleLoading"  style="width:100%" v-if="menunumber==2">
		            <el-table-column type="expand" inline class="demo-table-expand">
			            <template slot-scope="props">
			                <el-table :data="props.row.goods">
				                <el-table-column prop="name" label="消费项目"></el-table-column>
				                <el-table-column prop="numbers" label="数量"></el-table-column>
				                <el-table-column prop="amount" label="总价"></el-table-column>
			                </el-table>
			            </template>
		            </el-table-column>
		            <el-table-column prop="ordernum" label="订单号"></el-table-column>
		            <el-table-column prop="order_amout" label="总价"></el-table-column>
				    <el-table-column prop="inputtime" label="时间"></el-table-column>
	            </el-table>
	            <div class="block" v-if="menunumber==2">
			        <el-pagination
			            @size-change="productsalePageSizeChange"
			            @current-change="productsalePageCurrentChange"
			            :current-page="salequery.p"
			            :page-sizes="[10, 20, 50]"
			            :page-size="salequery.rollpage"
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="salerow">
			        </el-pagination>
			    </div>
		    </div>
  			<!------------------------------------  店铺销售记录 -------------------------------------------->
  			
  			<!------------------------------------  产品销售统计 -------------------------------------------->
  			<div>
  				<el-form :inline="true" class="demo-form-inline"  style="margin-top:15px" v-if="menunumber==3">
		            <el-form-item style="width:25%">
			            <el-date-picker v-model="salestatquery.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:100%" @change="salestat=true"></el-date-picker>
		            </el-form-item>
		            <el-form-item>
		            	<el-input placeholder="商品名称" size="25" v-model="salestatquery.key" @change="salestat=true"></el-input>
		            </el-form-item>
		            <el-form-item>
		            	<el-button type="primary" icon="el-icon-search" @click="getgoodssalesdata()">查询</el-button>
		            </el-form-item>
	        	</el-form>
	        	<el-table :data="salestatlists" v-loading="salestatLoading"  style="width:100%" v-if="menunumber==3">
		            <el-table-column prop="name" label="商品名称"></el-table-column>
		            <el-table-column prop="numbers" label="销售数量" align="center"></el-table-column>
				    <el-table-column prop="amount" label="销售总价" align="center"></el-table-column>
	            </el-table>
	        	<div class="block" v-if="menunumber==3">
			        <el-pagination
			            @size-change="productsalestatPageSizeChange"
			            @current-change="productsalestatPageCurrentChange"
			            :current-page="salestatquery.p"
			            :page-sizes="[10, 20, 50]"
			            :page-size="salestatquery.rollpage"
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="salestatrow">
			        </el-pagination>
			    </div>
  			</div>
  			<!------------------------------------  产品销售统计 -------------------------------------------->
  			
  			<!------------------------------------  销售额统计 --------------------------------------------->
			<div class="brand block" v-if="menunumber==4">
				<IEcharts :option="brand" :loading="brandloading" v-if="menunumber==4"/>
			</div>
	        <!------------------------------------  销售额统计 --------------------------------------------->
	        
	        <!------------------------------------  按产品分类统计  ------------------------------------------>
	        <el-form :inline="true" class="demo-form-inline"  style="margin-top:15px" v-if="menunumber==5">
		    	<el-form-item style="width:20%">
		    		<el-date-picker v-model="statdate" type="month" placeholder="请选择月份" value-format="yyyy-MM"></el-date-picker>		
		        </el-form-item>
		        <el-form-item>
		            <el-button type="primary" icon="el-icon-search" @click="getcatesall()">查询</el-button>
		        </el-form-item>
	       	</el-form>
	        <div class="catebox block" v-if="menunumber==5">
	            <div class="left">
					<IEcharts :option="categorylists" :loading="categoryloading" v-if="menunumber==5"/>
				</div>
				<div class="right">
					<IEcharts :option="suplierlists" :loading="brandlistsloading" v-if="menunumber==5"/>
				</div>
			</div>
	        <!------------------------------------  按产品分类统计  ------------------------------------------>
  			  			
	    </el-dialog>
	    
    </div>
    </transition>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Shop/index",
      transitionshow:true,
      lists:[],
      listLoading:false,
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        level:'',
        validtime:'',
        rollpage: 10, // 页大小
        p: 1
      },
      
      signquery:{
        act:'getclerksign',
        token:this.$cookies.get('token'),
        p: 1,
        rollpage: 10, // 页大小
      },
      
      total_rows: 0,
      sign_total_rows: 0,
      
      levels: [
      	  {id:0,name:'全部'},
      	  {id:1,name:'专业版'},
      	  {id:2,name:'商业版'},
      	  {id:3,name:'旗舰版'},
      ],
      
      validtime: [
      	  {id:0,name:'全部'},
      	  {id:1,name:'当天到期'},
      	  {id:2,name:'一周内到期'},
      	  {id:3,name:'一个月内到期'},
      	  {id:4,name:'三个月内到期'},
      ],
	  
	  /** 店铺数据相关 **/
	  shopInventoryquery:{
	  	  act:'getshopinventory',
	  	  token:this.$cookies.get('token'),
	  	  id:'',
	  	  brandid:'',
	  	  catid:'',
	  	  key:'',
	  	  p:1,
	  	  rollpage:10
	  },
	  shopname:'',
	  shopsinfosDialog:false,
	  shopsellDialog:false,
	  shopindex:1,
	  shopinventorydata:[],
	  shopinventoryrow:0,      
	  brandlists:[],
	  catlists:[],
	  inventoryLoading:false,
	  inventoryselect:false,
	  shopid:'',
	  
	  /** 店铺销售记录信息相关 **/
	  salequery:{
	  	  act:'getshopsalelists',
	  	  token:this.$cookies.get('token'),
	  	  id:'',
	  	  date:'',
	  	  p:1,
	  	  rollpage:10,
	  },
	  saleLoading:false,
	  salelists:[],
	  salerow:0,
	  menunumber:'',
	  
	  /** 店铺销售统计信息相关 **/
	  salestatquery: {
	  	  act:'getshopsalestats',
	  	  token:this.$cookies.get('token'),
	  	  id:'',
	  	  date:'',
	  	  key:'',
	  	  p:1,
	  	  rollpage:10,
	  },
	  salestat:false,
	  salestatlists:[],
	  salestatrow:0,
	  salestatLoading:false,
	  
	  /** 销售额统计相关 **/
	  brandloading:false,
	  brand:{
      	  tooltip: {},
          xAxis: {
              data: []
          },
          yAxis: {},
          series: []
      },
      
      /** 分类统计相关 **/
	  categoryloading:false,
	  brandlistsloading:false,
	  categorylists:{
	  	  title:{
		      text: '商品销售分类前十位比例分析',
		      x:'left'
		  },
		  tooltip : {
		      trigger: 'item',
		      formatter: "{a} <br/>{b} : {c} ({d}%)"
		  },
		  series : [{
              name: '访问来源',
              type: 'pie',
              radius : '55%',
              center: ['50%', '60%'],
              data:[],
              itemStyle: {
                  emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
              }
          }]
	  },
	  suplierlists:{
	  	  title:{
		      text: '商品品牌销售前十位比例分析',
		      x:'left'
		  },
		  tooltip : {
		      trigger: 'item',
		      formatter: "{a} <br/>{b} : {c} ({d}%)"
		  },
		  series : [{
              name: '访问来源',
              type: 'pie',
              radius : '55%',
              center: ['50%', '60%'],
              data:[],
              itemStyle: {
                  emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
              }
          }]
	  },
	  statdate:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1),
	  
    }
  },
  components: {
    IEcharts
  },
  mounted(){
    this.getactionauth();
    this.getTrends();
    this.getList();
  },
  methods:{
  
    /** 获取功能权限  **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
  
    /** 信息列表 **/
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
      console.log(res);
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    /** 获取系统分类信息 **/
    getcategory() {
    	var resource = this.$resource(this.url);
	    resource.query({act:'getcats',token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
	        }else{
		        this.catlists = JSON.parse(Base64.decode(res.data.Data));
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    /** 获取店铺商品品牌记录信息 **/
    getsysbrand() {
    	var resource = this.$resource(this.url);
	    resource.query({act:'getsysbrand',token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
	        }else{
		        this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    
    /** 获取店铺的信息 **/
    getShopinfo(item) {
    	this.shopname=item.shopname+'店铺信息';
    	this.shopid=item.id;

    	this.getsysbrand(); //获取品牌信息列表
    	this.getcategory(); //获取系统商品分类列表
    	this.shopsinfosDialog=true;
		this.getshopinventorylists(); //获取商品库存记录列表
    },
    
    /** 点击库存记录按钮 **/
    getshopinventorylists() {
    	if(this.actionauth.inventory_log=='true' || (this.actionauth.inventory_log=='true' && this.actionauth.sell_log=='true')) { //有商品销售权限时
    		this.shopindex=1;
	    	this.menunumber=1;
	    	this.shopInventoryquery.id=this.shopid;
	    	this.shopInventoryquery.brandid='';
	    	this.shopInventoryquery.catid='';
	    	this.shopInventoryquery.key='';
	    	this.shopInventoryquery.p=1;
	    	this.shopInventoryquery.rollpage=10; 	
    		this.getshopinventory(); //获取销售商品信息	
    	}
    	
    	if(this.actionauth.inventory_log!='true' && this.actionauth.sell_log=='true') { //无商品销售权限但有查看商品销售记录权限
    		this.saleslog();	
    	}
    	
    	if(this.actionauth.inventory_log!='true' && this.actionauth.sell_log!='true'){
    		this.salestatlog();
    	}
    	
    },
    
    
    /** 获取店铺商品库存记录信息 **/
    getshopinventory() {
    	if(this.inventoryselect==true) {
			this.shopInventoryquery.p=1;
			this.shopInventoryquery.rollpage=10;	    	
    	}
    
    	this.inventoryLoading=true;
    	var resource = this.$resource(this.url);
	    resource.query(this.shopInventoryquery).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.inventoryLoading=false;
	        }else{
		        this.shopinventorydata = JSON.parse(Base64.decode(res.data.Data));
          		this.shopinventoryrow=parseInt(res.data.count);
          		this.inventoryLoading=false;
	        }
	        
	        if(this.inventoryselect==true) this.inventoryselect=false;
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	        this.inventoryLoading=false;
	        if(this.inventoryselect==true) this.inventoryselect=false;
	    });
    },
    productinventoryPageSizeChange(val) {
        this.shopInventoryquery.rollpage = val;
        this.getshopinventory();
    },
    productinventoryPageCurrentChange(val) {
        this.shopInventoryquery.p = val;
        this.getshopinventory();
    },
    
    
    /** 店铺销售记录信息 **/
    saleslog() {
    	this.shopindex=2;
    	this.menunumber=2;
    	this.salequery.id=this.shopid;
    	this.salequery.date='';
    	this.salequery.p=1;
    	this.salequery.rollpage=10;

    	this.getsalesdata(); //获取销售记录数据
    },
    
    /** 获取店铺商品库存记录信息 **/
    getsalesdata() {    
    	this.saleLoading=true;
    	var resource = this.$resource(this.url);
	    resource.query(this.salequery).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.saleLoading=false;
	        }else{
		        this.salelists = JSON.parse(Base64.decode(res.data.Data));
          		this.salerow=parseInt(res.data.count);
          		this.saleLoading=false;
	        }
	        
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	        this.saleLoading=false;
	    });
    },
    productsalePageSizeChange(val) {
        this.salequery.rollpage = val;
        this.getsalesdata();
    },
    productsalePageCurrentChange(val) {
        this.salequery.p = val;
        this.getsalesdata();
    },
    
    
    /** 获取产品统计信息 **/
    salestatlog() {
    	this.shopindex=3;
    	this.menunumber=3;
    	this.salestatquery.id=this.shopid;
    	this.salestatquery.date='';
    	this.salestatquery.key='';
    	this.salestatquery.p=1;
    	this.salestatquery.rollpage=10;
    	
    	this.getgoodssalesdata();
    },
    
    /** 获取店铺商品统计信息 **/
    getgoodssalesdata() {
    	if(this.salestat==true) {
			this.salestatquery.p=1;
			this.salestatquery.rollpage=10;	    	
    	}
        
    	this.salestatLoading=true;
    	var resource = this.$resource(this.url);
	    resource.query(this.salestatquery).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.saleLoading=false;
	        }else{
		        this.salestatlists = JSON.parse(Base64.decode(res.data.Data));
          		this.salestatrow=parseInt(res.data.count);
          		this.salestatLoading=false;
	        }
	        
	        if(this.salestat==true) this.salestat=false;
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	        this.salestatLoading=false;
	        if(this.salestat==true) this.salestat=false;
	    });
    },    
    productsalestatPageSizeChange(val) {
        this.salestatquery.rollpage = val;
        this.getgoodssalesdata();
    },
    productsalestatPageCurrentChange(val) {
        this.salestatquery.p = val;
        this.getgoodssalesdata();
    },
    
    
    /** 获取店铺一年营业走势图 **/
    getsalesall() {
    	this.shopindex=4;
    	this.menunumber=4;
    	this.getTrends();
    },
    
    /** 获取店铺一年营业走势（按当前年、月分） **/
    getTrends(){
        this.brandloading=true;
        var resource = this.$resource(this.url);
        resource.query({act:'getsellstrend',id:this.shopid,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.brandloading=false;
	        }else{
	        	this.brand.xAxis.data = [];
	            this.brand.series = [];
	            var info = JSON.parse(Base64.decode(res.data.Data));
	            this.brand.xAxis.data = info.xAxis;
	            this.brand.series = info.series;
	            this.brandloading=false;	            
	        }
        }).catch((res) => {
            this.brandloading=false;
        });
    },
    
    
    /** 获取分类统计和品牌统计信息列表（统计当前年份） **/
    getcatesall() {
    	this.shopindex=5;
    	this.menunumber=5;
    	this.getcatestats();
    	this.getbrandlists();
    },
    
    /** 获取分类信息统计 **/
    getcatestats() {
    	this.categoryloading=true;
        var resource = this.$resource(this.url);
        resource.query({act:'getcatestats',id:this.shopid,date:this.statdate,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.brandloading=false;
	        }else{
	        	this.categorylists.series[0]['data']=[];
	            var info = JSON.parse(Base64.decode(res.data.Data));
	            
	            this.categorylists.series[0]['data']=info;
	            this.categoryloading=false;	            
	        }
        }).catch((res) => {
            this.categoryloading=false;
        });
    },
    
    /** 获取分类信息统计 **/
    getbrandlists() {
    	this.brandlistsloading=true;
        var resource = this.$resource(this.url);        
        resource.query({act:'getbrandstats',id:this.shopid,date:this.statdate,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.brandlistsloading=false;
	        }else{
	        	this.suplierlists.series[0]['data']=[];
	            var info = JSON.parse(Base64.decode(res.data.Data));
	            this.suplierlists.series[0]['data']=info;
	            this.brandlistsloading=false;	            
	        }
        }).catch((res) => {
            this.brandlistsloading=false;
        });
    },
    
     
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.brand{width:100%;height:400px;margin-top:30px;}
.catebox {width:100%;height:500px;margin-top:30px;}
.catebox .left {width:50%;float:left;height:500px;}
.catebox .right {width:50%;float:left;height:500px;}
</style>


// WEBPACK FOOTER //
// src/components/shop/Lists.vue